<p-dialog
  [maximizable]="maximizable"
  [breakpoints]="breakpoints"
  [style]="dialogStyle"
  [resizable]="resizable"
  [header]="header"
  (onHide)="closeDialog()"
  [modal]="modal"
  [(visible)]="visible"
  [closable]="!hideCancel"
>
  <div>
    <ng-content></ng-content>
  </div>

  <ng-template pTemplate="footer" *ngIf="showFooter">
    <button type="button" class="btn btn-danger" (click)="closeDialog()" *ngIf="!hideCancel">
      {{ "common.cancel" | translate }}
    </button>
    <button
      *ngIf="showSecondButton"
      [disabled]="saveButtonDisable"
      type="button"
      class="btn btn-info"
      (click)="secondButtonSave()"
    >
      {{ secondButtonText }}
    </button>
    <button
      [disabled]="saveButtonDisable"
      type="button"
      class="btn btn-success"
      (click)="save()"
    >
      {{ saveText }}
    </button>

  </ng-template>
</p-dialog>
